import { api } from "@/lib/api/api";
import { args } from "@/lib/args/args";
import { expectShape } from "@/lib/expect/expect-shape";
import { is } from "@/lib/is/is";
import { out } from "@/lib/output/out";
import type { Scope } from "@/commands/scope/scope";
import type { ApiOutputs } from "@/lib/api/api-outputs";
import type { ParsedArgs } from "@/lib/parsed/parsed-args";

export async function createKey(
  parsed: ParsedArgs,
  asJson: boolean,
): Promise<void> {
  args.expect(parsed, { flags: ["scope", "expires-in-days"], positional: 2 });
  const name = args.required(parsed, 1, "name");
  const scopes = parsed.repeated.scope as Scope;
  const expiresInDays = args.integer(parsed, "expires-in-days", {
    min: 1,
    max: 365,
  });
  const created = expectShape<ApiOutputs["keys"]["create"]>(
    await api("/keys", {
      method: "POST",
      body: {
        name,
        ...(scopes && scopes.length > 0 ? { scopes } : {}),
        ...(expiresInDays !== undefined ? { expiresInDays } : {}),
      },
    }),
    "POST /keys",
    { key: is.string, scopes: is.array },
  );
  if (asJson) {
    out.json(created);
    return;
  }
  out.line(
    `${out.paint("✓", "green")} Created "${out.cell(created.name ?? name)}"`,
  );
  out.line();
  out.line(`  ${out.paint(created.key, "bold")}`);
  out.line();
  out.line(
    out.paint(
      "  Copy it now; it is hashed at rest and never shown again.",
      "dim",
    ),
  );
  out.line(out.paint(`  Scopes: ${created.scopes.join(" ")}`, "dim"));
}
